<template>
  <transition name="router-fade" mode="out-in">
    <div class="mask" v-if="activeimg.length" @click="closeimg">
      <swiper :options="swiperOption" ref="mySwiper" class="swiper-container2">
        <swiper-slide class="flex-box" v-for="(item,index) in activeimg" :key="index">
          <img :src="item"  @click="closeimg">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </transition>
</template>

<script>
  export default {
    data () {
      var self = this;
      return {
        swiperOption: {
          pagination: '.swiper-pagination',
          paginationClickable: true,
          initialSlide: 0,
          autoplayDisableOnInteraction: false,
        },
      }
    },
    created () {
      console.log(this.activeimg)
      this.swiperOption.initialSlide = this.indeximg
    },
    props: ['activeimg', 'indeximg'],
    methods: {
      closeimg () {
        this.$emit('closeimg')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/css/mixin';
  .mask{
    background-color: rgba(0,0,0,1);
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    img{
      @include center();
      width: 100%;
    }
  }
  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }
  .swiper-container2{
    @include wh(100vw,calc(100vh - 1rem));
  }
</style>



// WEBPACK FOOTER //
// lookimg.vue?5da78dd9